<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,9C8,9,9,9,9,9C9,9,9,10,9,10C9,10.55,9.45,11,10,11C10.55,11,11,10.55,11,10C11,10,11,9,11,9C11,9,12,9,12,9C12.55,9,13,8.55,13,8C13,7.45,12.55,7,12,7C12,7,11,7,11,7C11,7,11,6,11,6C11,5.45,10.55,5,10,5C9.45,5,9,5.45,9,6C9,6,9,7,9,7C9,7,8,7,8,7C7.45,7,7,7.45,7,8C7,8.55,7.45,9,8,9C8,9,8,9,8,9ZM15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM5,14C5,14,2,14,2,14C2,14,2,2,2,2C2,2,5,2,5,2C5,2,5,14,5,14C5,14,5,14,5,14ZM14,14C14,14,6,14,6,14C6,14,6,2,6,2C6,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AddColumnRight',
} as DefineComponent
</script>
